// extracted by mini-css-extract-plugin
module.exports = {"dollarInput":"dollarInput_2KrZL","inputLabel":"inputLabel_2Lv73","dollarLabel":"dollarLabel_3ufOP","error":"error_1he8B"};